(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-game-preview/assets/javascripts/casino-game-preview.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-game-preview/assets/javascripts/casino-game-preview.js');

'use strict';

const {
  Image
} = svs.content.image_v2;
const {
  CardBody
} = svs.ui.ReactCard;
const {
  ReactIcon: Icon,
  ReactIconButton: IconButton,
  ReactButton: Button
} = svs.ui;
const {
  useSearchResults,
  useFavorites
} = svs.components.casino_react.casinoStore.hooks;
const {
  useCallback,
  useState,
  memo
} = React;
const {
  Link
} = ReactRouterDOM;
const {
  getAnalyticsPosition
} = svs.components.casino_react.analytics_utils.utils;
const {
  dispatchGameToLastSearched
} = svs.components.casino_react.casinoStore.utils.lastSearched;
const {
  CardType
} = svs.components.casino_react.common.constants;
const urlMapping = svs.core.urlMapping;
const {
  useLiveData
} = svs.components.casino_react.casino_store.hooks;
const {
  CasinoGamePlayers
} = svs.components.casino_react.casino_game_live_info;
const {
  startGameAsync
} = svs.components.casino.shared;
const {
  Loader
} = svs.components.ReactLoader;
const {
  CasinoGamePlayTypes
} = svs.components.casino_react.common.constants;
const cmsProviderList = svs.casino_react.shared.data.cmsProviderList;
const {
  brand
} = svs.casino_react.shared.data;
const getFallbackImage = () => {
  let image = 'fallback-img-casino.jpg';
  if (brand === 'momang') {
    image = 'fallback-img-momang.jpg';
  }
  return "".concat(svs.core.config.data.svsconfig.cdn, "/images/casino-react/casino-game-preview/").concat(image, "?breakCache=1");
};
const ImageMemoized = memo(Image);
const CasinoGamePreview = _ref => {
  var _cmsProviderList$find;
  let {
    gameModel,
    imageSource,
    isVisableFromBottomSheet
  } = _ref;
  const {
    liveData
  } = useLiveData(gameModel);
  const {
    latestSearchQuery
  } = useSearchResults();
  const {
    isFavorite,
    toggleFavorite,
    isPending,
    isLoggedIn
  } = useFavorites();
  const [loadingType, setLoadingType] = useState(null);
  const {
    title,
    provider,
    rtp,
    winLines,
    freePlayAllowed,
    name
  } = gameModel;
  const handleFavoriteClick = useCallback(async () => {
    if (!isLoggedIn) {
      svs.components.customer_login.login();
      return;
    }
    await toggleFavorite(name);
  }, [isLoggedIn, toggleFavorite, name]);
  const isFav = isFavorite(name);
  const providerModel = cmsProviderList === null || cmsProviderList === void 0 || (_cmsProviderList$find = cmsProviderList.find(item => item.model.provider === provider)) === null || _cmsProviderList$find === void 0 ? void 0 : _cmsProviderList$find.model;
  const providerPath = "".concat(urlMapping.get('casinoProvider'), "/").concat(providerModel === null || providerModel === void 0 ? void 0 : providerModel.systemName);
  const returnUrl = window.location.pathname + window.location.search;
  const onProviderPage = window.location.pathname.includes(urlMapping.get('casinoProvider'));
  const providerLink = "".concat(providerPath, "?returnUrl=").concat(encodeURIComponent(returnUrl));
  const infoLink = "".concat(urlMapping.get('casinoGameInfo'), "/").concat(name, "?returnUrl=").concat(encodeURIComponent(returnUrl));
  const handleClick = useCallback(async (e, playType) => {
    e.preventDefault();
    setLoadingType(playType);
    const currentIndex = '';
    if (latestSearchQuery) {
      dispatchGameToLastSearched("".concat(CardType.GAME, "_").concat(gameModel.name));
    }
    try {
      const canPlay = await startGameAsync(playType, gameModel.name, {
        name: gameModel.name,
        title: "".concat(gameModel.name, ";").concat(currentIndex),
        position: "".concat(getAnalyticsPosition({
          isSearched: Boolean(latestSearchQuery)
        }), ";").concat(gameModel.name)
      }, gameModel, Boolean(latestSearchQuery));
      if (!canPlay) {
        setLoadingType(null);
      }
    } catch (_unused) {
      setLoadingType(null);
    }
  }, [gameModel, latestSearchQuery]);
  return React.createElement(CardBody, {
    center: true,
    className: "game-preview-body"
  }, React.createElement("div", {
    className: "image-wrapper-container"
  }, imageSource && React.createElement(ImageMemoized, {
    fallbackImage: getFallbackImage(),
    image: imageSource
  }), React.createElement(IconButton, {
    "aria-label": isFav ? 'Ta bort från favoriter' : 'Lägg till i favoriter',
    className: "game-preview-body__favorites-btn",
    disabled: isPending,
    onClick: handleFavoriteClick,
    tabIndex: isVisableFromBottomSheet ? 0 : -1,
    title: isFav ? 'Ta bort från favoriter' : 'Lägg till i favoriter'
  }, React.createElement(Icon, {
    color: "icon-inverted",
    icon: isFav ? 'favorites-filled' : 'favorites',
    size: "300"
  }))), React.createElement("div", {
    className: "game-preview-body__content"
  }, React.createElement("div", {
    className: "game-preview-body__title-provider-wrapper"
  }, React.createElement("h3", {
    className: "game-preview-body__title"
  }, title), providerModel !== null && providerModel !== void 0 && providerModel.systemName && !onProviderPage ? React.createElement(Link, {
    className: "game-preview-body__provider-link",
    tabIndex: isVisableFromBottomSheet ? 0 : -1,
    title: "Visa spel fr\xE5n ".concat(providerModel === null || providerModel === void 0 ? void 0 : providerModel.provider),
    to: providerLink
  }, providerModel === null || providerModel === void 0 ? void 0 : providerModel.provider) : React.createElement("span", null, gameModel === null || gameModel === void 0 ? void 0 : gameModel.provider)), React.createElement("ul", null, rtp > 0 && React.createElement("li", null, "RTP:", ' ', React.createElement("span", {
    className: "game-preview-body__list-text"
  }, rtp, "%")), winLines > 0 && React.createElement("li", null, "Vinstlinjer:", ' ', React.createElement("span", {
    className: "game-preview-body__list-text"
  }, winLines, ' ', "st")), React.createElement(CasinoGamePlayers, {
    gameModel: gameModel,
    liveData: liveData
  })), React.createElement("div", {
    className: "game-preview-body__button-group"
  }, freePlayAllowed && React.createElement(Button, {
    disabled: Boolean(loadingType),
    href: "".concat(urlMapping.get('casinoDemoPlay'), "/").concat(name),
    inverted: true,
    onClick: e => handleClick(e, CasinoGamePlayTypes.demoPlay),
    rel: "nofollow",
    tabIndex: isVisableFromBottomSheet ? 0 : -1,
    transparent: true,
    type: "button"
  }, loadingType === CasinoGamePlayTypes.demoPlay ? React.createElement(Loader, {
    size: 200
  }) : 'Provspela'), React.createElement(Button, {
    disabled: Boolean(loadingType),
    href: "".concat(urlMapping.get('casinoGamePlay'), "/").concat(name),
    onClick: e => handleClick(e, CasinoGamePlayTypes.gamePlay),
    rel: "nofollow",
    tabIndex: isVisableFromBottomSheet ? 0 : -1,
    type: "button"
  }, loadingType === CasinoGamePlayTypes.gamePlay ? React.createElement(Loader, {
    inverted: true,
    size: 200
  }) : 'Spela'), React.createElement(Button, {
    className: "game-preview-body__ghost-button",
    href: infoLink,
    onClick: () => {
      if (latestSearchQuery) {
        dispatchGameToLastSearched("".concat(CardType.GAME, "_").concat(name));
      }
    },
    rel: "follow",
    tabIndex: isVisableFromBottomSheet ? 0 : -1,
    type: "button"
  }, "L\xE4s mer"))));
};
setGlobal('svs.components.casino_react.casinoGamePreview.CasinoGamePreview', CasinoGamePreview);

 })(window);